import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body" }
const _hoisted_6 = { class: "overflow-auto" }
const _hoisted_7 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_8 = { class: "text-capitalize-first w-25" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "form-group col-sm-12" })
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.trader')), 1),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.req_count')), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.active_req_count')), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (group) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: group.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, _toDisplayString(group.id), 1),
                          _createElementVNode("td", null, _toDisplayString(group.name), 1),
                          _createElementVNode("td", null, [
                            (group.trader)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  user: group.trader
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(group.requisitesCount), 1),
                          _createElementVNode("td", null, _toDisplayString(group.activeRequisitesCount), 1),
                          _createElementVNode("td", _hoisted_13, [
                            (_ctx.isAdmin || _ctx.isOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.toggleRequisites(group, false)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap me-2"
                                }, [
                                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-toggle-off text-secondary" }, null, -1)),
                                  _cache[4] || (_cache[4] = _createTextVNode()),
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.requisites_deactivate')), 1)
                                ], 8, _hoisted_14))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.toggleRequisites(group, true)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap"
                                }, [
                                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-toggle-on text-success" }, null, -1)),
                                  _cache[6] || (_cache[6] = _createTextVNode()),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.helper.trans('labels.requisites_activate')), 1)
                                ], 8, _hoisted_16))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[1] || (_cache[1] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": _ctx.helper.trans('button.back'),
                        "next-text": _ctx.helper.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}